import { Title, Text } from "@tremor/react";
export function EmptyBuilderState() {
  return <div className="flex flex-col h-full justify-center items-center" data-sentry-component="EmptyBuilderState" data-sentry-source-file="empty-builder-state.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="empty-builder-state.tsx">Please start by loading or creating a new workflow</Title>
      <Text data-sentry-element="Text" data-sentry-source-file="empty-builder-state.tsx">
        Load YAML or use the &quot;New&quot; button from the top right menu
      </Text>
    </div>;
}